import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyItDidntWork() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const reasons = [{
    title: 'Las infusiones calientes antes de dormir',
    description: 'suelen empeorar tu temperatura central.'
  }, {
    title: 'Las pastillas para dormir',
    description: 'te dejan "noqueada" pero no te dan sueño reparador, causándote niebla mental al día siguiente.'
  }, {
    title: 'Las meditaciones de "nubes blancas"',
    description: 'no funcionan cuando tu cuerpo está enviando señales físicas de alerta biológica.'
  }, {
    title: 'Ignorar el problema',
    description: 'solo está acelerando tu envejecimiento y afectando tu metabolismo.'
  }];
  return <section ref={ref} className="w-full bg-[#f8f4e8] py-20 md:py-32" data-id="element-213">
      <div className="max-w-5xl mx-auto px-6" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-215">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#0f172a] text-center" data-id="element-216">
            Por Qué Lo Que Intentaste No Funcionó
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-217">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            delay: index * 0.1,
            duration: 0.6
          }} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#d4a853]" data-id="element-218">
                <div className="flex gap-4" data-id="element-219">
                  <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-220" />
                  <div className="space-y-2" data-id="element-221">
                    <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-222">
                      {reason.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed" data-id="element-223">
                      {reason.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}